import React from 'react';
import styled from 'styled-components';

import BasicCardTop from './BasicCardTop';

const FullCardTopWrapper = styled(BasicCardTop)`
    img {
        width: 100%; 
        height: 100%; 
        object-fit: cover;
        max-width: initial;
        max-height: initial;
    }
`
 
const FullCardTop = ({ cardImage }) => {{
    return (
        <FullCardTopWrapper cardImage={cardImage} />
    )
}}
 
export default FullCardTop